import { BreadcrumbItem } from '@mi-front/ui';
import { Box, Breadcrumbs, Link } from '@mui/material';
import React from 'react';
import { useIntl } from 'react-intl';
import { Link as RouterLink } from 'react-router-dom';

export interface PageBreadcrumbsProps {
  readonly items?: readonly BreadcrumbItem[];
}

export const PageBreadcrumbs = ({ items }: PageBreadcrumbsProps) => {
  const { $t } = useIntl();

  const renderItem = (item: BreadcrumbItem) => (
    <Box display="flex" alignItems="center" gap={1}>
      {item.icon}
      {item.content}
    </Box>
  );

  return (
    <Breadcrumbs
      aria-label={$t({
        id: 'common.breadcrumb',
        defaultMessage: 'Breadcrumb',
      })}
      separator={'/'}
      sx={{
        fontSize: 'small',
        fontWeight: '400',
        color: 'text.secondary',
        '& .MuiBreadcrumbs-separator': {
          color: 'text.disabled',
          fontWeight: '400',
          mx: 1.5,
        },
        '& a': {
          color: 'text.secondary',
        },
      }}
    >
      {items?.map((item, index) => {
        if (item.active) {
          return <React.Fragment key={index}>{renderItem(item)}</React.Fragment>;
        }

        if (!item.href) {
          return <React.Fragment key={index}>{renderItem(item)}</React.Fragment>;
        }

        return (
          <Link key={index} component={RouterLink} to={item.href} underline="hover">
            {renderItem(item)}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
};
